const state = {
  applicationStateData: {},
  mapUploadedFileUrlName: {},
  mapUploadedFileUrlSize: {}
};

const mutations = {
  setApplicationStateData(state, payload) {
    state.applicationStateData = payload;
  },
  addUploadedFileUrlName(state, payload) {
    if (!state.mapUploadedFileUrlName) {
      state.mapUploadedFileUrlName = {}
    }
    state.mapUploadedFileUrlName[payload.url] = payload.name
  },
  addUploadedFileUrlSize(state, payload) {
    if (!state.mapUploadedFileUrlSize) {
      state.mapUploadedFileUrlSize = {}
    }
    state.mapUploadedFileUrlSize[payload.url] = payload.size;
    state.mapUploadedFileUrlSize = { ...state.mapUploadedFileUrlSize };
  }
};

const actions = {
  setApplicationStateData({ commit }, payload) {
    commit("setApplicationStateData", payload);
  },
  addUploadedFileUrlName({ commit }, payload) {
    commit("addUploadedFileUrlName", payload);
  },
  addUploadedFileUrlSize({ commit }, payload) {
    commit("addUploadedFileUrlSize", payload);
  },

};

const getters = {
  applicationStateData(state) {
    return state.applicationStateData;
  },
  mapUploadedFileUrlName(state) {
    return state.mapUploadedFileUrlName;
  },
  mapUploadedFileUrlSize(state) {
    return state.mapUploadedFileUrlSize;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/form-data.js